import { render, staticRenderFns } from "./AllDisputesPage.vue?vue&type=template&id=7208c72a&scoped=true"
import script from "./AllDisputesPage.vue?vue&type=script&lang=js"
export * from "./AllDisputesPage.vue?vue&type=script&lang=js"
import style0 from "./AllDisputesPage.vue?vue&type=style&index=0&id=7208c72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208c72a",
  null
  
)

export default component.exports